import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

/** Base styles for the drawer panel (motion.div). */
export const panelBaseStyle = css`
  background: ${theme.colors.white};
  position: absolute;
  z-index: ${theme.zIndex.modals};
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(4)};
  gap: ${theme.spacing(2)};
`;

/**
 * Applied when `keepMounted` is true — overrides positioning to `fixed` so the
 * panel stays in the viewport even when its scroll container moves.
 */
export const panelKeepMountedStyle = css`
  position: fixed;
  bottom: 0;
`;

/** Base styles for the floating overlay backdrop. */
export const overlayBaseStyle = css`
  background-color: rgba(0, 33, 82, 0.3);
  position: fixed;
  top: 0;
  height: 100%;
`;

/**
 * Applied when there is a viewport height offset (e.g. a top banner). The dynamic
 * height is supplied via the `--drawer-overlay-height` custom property set inline.
 * `!important` is required to beat FloatingOverlay's inline lockScroll styles.
 */
export const overlayAdjustedHeightStyle = css`
  height: var(--drawer-overlay-height) !important;
  top: auto !important;
  bottom: 0 !important;
`;
